
export const UNAUTHORIZED_NAMING = ['wide', 'admin', 'test', 'fuck', 'aaaa', "1111", "12345", 'sexy', 'porn']